import { cilCalendarCheck, cilBriefcase, cilSpeedometer, cilStorage, cilTruck } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { CNavItem } from '@coreui/react-pro'
import React from 'react'
import {
  MENU_DASHBOARD,
  MENU_MOBILE_INVENTORY,
  MENU_MOBILE_ITEMS,
  MENU_MOBILE_TODO,
  MENU_MOBILE_RECEIVING,
} from './constants/PermissionConstants'

const _navMobile = [
  {
    component: CNavItem,
    name: 'dashboard',
    to: '/dashboards/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    permissions: [MENU_DASHBOARD],
  },
  {
    component: CNavItem,
    name: 'todo',
    to: '/todo',
    icon: <CIcon icon={cilCalendarCheck} customClassName="nav-icon" />,
    permissions: [MENU_MOBILE_TODO],
  },
  {
    component: CNavItem,
    name: 'receiving',
    to: '/receiving-mobile',
    icon: <CIcon icon={cilTruck} customClassName="nav-icon" />,
    permissions: [MENU_MOBILE_RECEIVING],
  },
  {
    component: CNavItem,
    name: 'items',
    to: '/products/items',
    icon: <CIcon icon={cilBriefcase} customClassName="nav-icon" />,
    permissions: [MENU_MOBILE_ITEMS],
  },
  {
    component: CNavItem,
    name: 'inventory',
    to: '/products/inventory',
    icon: <CIcon icon={cilStorage} customClassName="nav-icon" />,
    permissions: [MENU_MOBILE_INVENTORY],
  },
]

export default _navMobile
